var _g, _g2, _g3, _g4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLang(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_897_1088)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.5238 5.51821C25.0633 4.94961 24.4668 4.63914 23.7447 4.63565C20.626 4.62518 17.5109 4.63216 14.3923 4.63216C14.3679 4.63216 14.3434 4.63914 14.2841 4.6496C14.3225 4.97402 14.3574 5.29496 14.3958 5.61938C14.7446 8.40661 15.0969 11.1973 15.4423 13.9846C15.7074 16.102 15.969 18.2195 16.2237 20.3335C16.3144 21.0904 16.0946 21.7498 15.5888 22.3219C14.5353 23.5184 13.4923 24.7184 12.4423 25.9184C12.4109 25.9568 12.383 25.9986 12.3516 26.0405H23.9958C24.4249 25.9393 24.8365 25.8103 25.1854 25.5172C25.6214 25.1475 25.8935 24.6905 25.9912 24.1254C25.9982 24.0835 26.0191 24.0451 26.0296 24.0067V6.71474C25.9354 6.28566 25.8063 5.87054 25.5238 5.51821ZM25.0912 10.9776C24.997 11.1345 24.84 11.1834 24.6691 11.1834C24.4424 11.1834 24.2156 11.1834 23.9749 11.1834V18.2718C23.9749 18.3067 23.9749 18.3381 23.9749 18.373C23.9575 18.659 23.7691 18.8369 23.4865 18.8334C23.204 18.83 23.0191 18.6451 23.0191 18.359C23.0156 17.4172 23.0191 16.4753 23.0191 15.5334V15.0136H20.6854C20.7202 15.073 20.7516 15.1253 20.783 15.1776C21.1598 15.816 21.2854 16.4927 21.0237 17.1974C20.6854 18.1148 20.0191 18.68 19.0458 18.8021C18.0481 18.9276 17.2702 18.5125 16.733 17.6683C16.6772 17.5811 16.6458 17.459 16.6458 17.3544C16.6458 17.1555 16.7818 16.9846 16.9353 16.9427C17.1656 16.8834 17.3783 16.9637 17.5109 17.1416C17.619 17.2881 17.7272 17.4416 17.8632 17.5567C18.3202 17.9404 19.0005 17.9823 19.5098 17.6788C20.026 17.3718 20.2807 16.7927 20.1726 16.1683C20.0749 15.5927 19.6284 15.1462 19.0319 15.0346C18.9377 15.0171 18.84 15.0136 18.7423 15.0102C18.4598 14.9927 18.2888 14.8148 18.2888 14.5322C18.2888 14.2532 18.4598 14.0648 18.7458 14.0578C19.1958 14.0439 19.576 13.8869 19.8691 13.5415C20.3888 12.9206 20.2667 11.9369 19.6109 11.4625C18.9586 10.988 17.9923 11.1659 17.5597 11.8497C17.4377 12.0415 17.2876 12.1497 17.0574 12.1427C16.7574 12.1287 16.569 11.8741 16.6458 11.5845C16.6597 11.5287 16.6876 11.4729 16.7156 11.4206C17.2109 10.5729 18.1981 10.1055 19.1435 10.2624C20.1446 10.4299 20.8981 11.1345 21.1005 12.1253C21.2365 12.7915 21.1319 13.416 20.7342 13.9811C20.7202 14.002 20.7098 14.0229 20.6888 14.0543H23.0121V11.1938C22.7819 11.1938 22.5551 11.1938 22.3284 11.1938C22.0807 11.1904 21.9202 11.0857 21.854 10.8904C21.7354 10.5415 21.9482 10.238 22.3144 10.2345C23.1098 10.231 23.9051 10.2345 24.7005 10.2345C24.8819 10.2345 25.0319 10.3043 25.1156 10.4717C25.1959 10.6357 25.1924 10.8101 25.0912 10.9776Z",
    fill: "#D84727"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_897_1088)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00348808 10.734C0.00348808 7.96419 0.00348808 5.19091 0.00348808 2.42112C0.00348808 1.43739 0.408143 0.673427 1.30815 0.247842C1.6256 0.0978404 2.00583 0.0176072 2.35816 0.0141188C4.9326 -0.0033232 7.51053 -0.0033231 10.085 0.00714211C11.4001 0.0106305 12.2827 0.88622 12.4536 2.27809C12.7676 4.85951 13.092 7.43744 13.4094 10.0154C13.7059 12.4084 13.999 14.8049 14.292 17.2015C14.428 18.3178 14.5571 19.4375 14.7141 20.5538C14.7664 20.9376 14.5711 21.1817 14.3408 21.4224C14.3025 21.4608 14.2152 21.4643 14.1525 21.4643C10.2036 21.4643 6.25471 21.4748 2.30583 21.4608C0.955822 21.4573 0 20.4457 0 19.0747C0 16.291 0.00348808 13.5142 0.00348808 10.734ZM7.96403 11.5538C7.97449 11.5956 7.98496 11.62 7.98844 11.6445C8.14193 12.4084 8.29194 13.1724 8.44891 13.9328C8.5431 14.3933 8.94078 14.6724 9.3559 14.5817C9.78497 14.4875 10.0361 14.0933 9.94544 13.6363C9.4466 11.1491 8.95124 8.65838 8.44891 6.17115C8.34775 5.66533 8.07566 5.44556 7.56635 5.44207C7.11634 5.43858 6.66983 5.43858 6.21982 5.44207C5.70703 5.44556 5.43842 5.66533 5.33726 6.17115C4.83842 8.65838 4.33957 11.1456 3.84073 13.6363C3.75003 14.0933 4.0012 14.4875 4.43376 14.5817C4.8419 14.6689 5.23261 14.4038 5.33377 13.9573C5.37912 13.7689 5.40703 13.577 5.4454 13.3852C5.56749 12.7747 5.68959 12.1642 5.81517 11.5503C6.54076 11.5538 7.24193 11.5538 7.96403 11.5538Z",
    fill: "#D84727"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_897_1088)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.9114 22.998C12.0707 23.926 11.2648 24.8155 10.452 25.6981C10.4102 25.7434 10.2811 25.7539 10.2218 25.7225C9.62877 25.3946 9.23458 24.9027 9.09155 24.2399C9.00434 23.8388 8.96946 23.4236 8.91016 23.0015C10.2427 22.998 11.5509 22.998 12.9114 22.998Z",
    fill: "#D84727"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i_897_1088)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.12305 10.0092C6.32537 8.99411 6.52421 7.99992 6.72654 6.98828C6.83468 6.98828 6.93934 6.98828 7.06143 6.98828C7.26027 7.99294 7.4626 8.99062 7.66492 10.0092C7.14864 10.0092 6.65328 10.0092 6.12305 10.0092Z",
    fill: "#D84727"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_897_1088",
    x: 12.3516,
    y: 4.62988,
    width: 13.6777,
    height: 22.4102,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_897_1088"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_897_1088",
    x: 0,
    y: 0,
    width: 14.7227,
    height: 22.4678,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_897_1088"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_897_1088",
    x: 8.91016,
    y: 22.998,
    width: 4.00195,
    height: 3.74219,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_897_1088"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_897_1088",
    x: 6.12305,
    y: 6.98828,
    width: 1.54102,
    height: 4.02051,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_897_1088"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLang);
export default __webpack_public_path__ + "static/media/lang.1cdc9ef84acbfb47967d06b0c1d47874.svg";
export { ForwardRef as ReactComponent };